module.exports = __webpack_public_path__ + "img/no-blocks.a140ba79.svg";